import { type FC } from 'react';
import { type UseFormReturn } from 'react-hook-form';

import { type IPersonalDetailsSchema, NIGERIAN_BANKS } from '../../pages/agent-application/create/helper';
import { TypeInput } from '../input';
import { TypeSelect } from '../select';

interface IPayoutDetailsProps {
	hookForm: UseFormReturn<IPersonalDetailsSchema>;
}

const PayoutDetails: FC<IPayoutDetailsProps> = ({ hookForm }) => {
	const {
		register,
		formState: { errors, dirtyFields },
	} = hookForm;

	const isFieldValid = (fieldName: keyof typeof dirtyFields) => {
		const isDirty = dirtyFields[fieldName];
		const hasError = !!errors[fieldName];
		return !!isDirty && !hasError;
	};

	return (
		<>
			<TypeInput
				label='Account Name'
				placeholder='As it appears on your bank account'
				type='text'
				customwidth='100%'
				error={errors.accountName?.message}
				isvalid={isFieldValid('accountName')}
				{...register('accountName')}
			/>
			<TypeInput
				label='Account Number'
				placeholder='10-digit NUBAN'
				type='tel'
				inputMode='numeric'
				maxLength={10}
				customwidth='100%'
				error={errors.accountNumber?.message}
				isvalid={isFieldValid('accountNumber')}
				{...register('accountNumber')}
			/>
			<TypeSelect
				label='Bank'
				initoption={{ label: 'Select your bank', value: '' }}
				optionsdata={NIGERIAN_BANKS}
				customwidth='100%'
				error={errors.bankName?.message}
				isvalid={isFieldValid('bankName')}
				{...register('bankName')}
			/>
		</>
	);
};

export default PayoutDetails;
